export const ImiVacantActionsTypesEnum = {
  ImiVacant: {
    key: "imi",
    value: "imi",
  },
};
